import GoalSetupScreen from '@components/GunlukOkuma/GoalSetupScreen'
import ReadingScreen from '@components/GunlukOkuma/ReadingScreen'
import { useUserData } from '@contexts/UserDataContext'
import LoadingSpinner from '@components/shared/Loading/Loading'
import { DefaultSeo } from 'next-seo'
import { useState } from 'react'

const GunlukOkumaPage = () => {
  const { userData, loading } = useUserData()
  const [isEditingGoal, setIsEditingGoal] = useState(false)

  if (loading) {
    return <LoadingSpinner />
  }

  const hasGoal = !!userData.readingChallenge

  return (
    <>
      <DefaultSeo
        title="Günlük Okuma | Hayırhah"
        description="Günlük Kuran okuma hedefinizi belirleyin ve ayet ayet okuyarak ilerlemenizi takip edin."
      />
      {hasGoal && !isEditingGoal ? (
        <ReadingScreen onEditGoal={() => setIsEditingGoal(true)} />
      ) : (
        <GoalSetupScreen onComplete={() => setIsEditingGoal(false)} />
      )}
    </>
  )
}

export default GunlukOkumaPage

